import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'simple-check-option',
  templateUrl: './simple-check-option.component.html',
  styleUrls: ['./simple-check-option.component.css']
})
export class SimpleCheckOptionComponent implements OnInit,OnChanges {
  @Input() value: any;
  @Input() label: string;
  //public control = new FormControl(false);
  @Input() control: FormControl;
  @Input() checkedValues: string[];
  isChecked: boolean;

  ngOnInit() {
    
  }
  ngOnChanges() {    
    if(this.checkedValues?.length > 0){      
      this.isChecked = this.checkedValues.includes(this.value);
    }
    
  }
}